var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSend(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.7426 7.35924L8.6093 3.79257C3.81764 1.39257 1.85097 3.35923 4.25097 8.1509L4.97597 9.6009C5.1843 10.0259 5.1843 10.5176 4.97597 10.9426L4.25097 12.3842C1.85097 17.1759 3.8093 19.1426 8.6093 16.7426L15.7426 13.1759C18.9426 11.5759 18.9426 8.95924 15.7426 7.35924ZM13.051 10.8926H8.55097C8.2093 10.8926 7.92597 10.6092 7.92597 10.2676C7.92597 9.9259 8.2093 9.64257 8.55097 9.64257H13.051C13.3926 9.64257 13.676 9.9259 13.676 10.2676C13.676 10.6092 13.3926 10.8926 13.051 10.8926Z",
    fill: "#328BDE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/send.dc9a01046af183113c3a82bb4a6e35a5.svg";
export { ForwardRef as ReactComponent };